import { uploadToursAndGenerateEmptyTraceGps } from "./command/uploadToursAndGenerateEmptyTraceGps";
import { scanCsv } from "./command/scanCsv";
import { sendCsvWithReport } from "./command/sendCsvWithReport";
import { getCsvScanReport } from "./command/getCsvScanReport";
import { getOperatorAndCarrierIds } from "./command/getOperatorAndCarrierIds";

export const tourClient = {
  uploadToursAndGenerateEmptyTraceGps: uploadToursAndGenerateEmptyTraceGps,
  scanCsv: scanCsv,
  getCsvScanReport: getCsvScanReport,
  sendCsvWithReport: sendCsvWithReport,
  getOperatorAndCarrierIds: getOperatorAndCarrierIds
};
